/**
 * src/hooks/useSla.js
 * React Query v5 hook para el resumen de SLA por cliente.
 */
import { useQuery } from '@tanstack/react-query'
import { getSlaResumen, getSlaInforme } from '../api/sla'

export function useSlaResumen() {
  return useQuery({
    queryKey: ['sla', 'resumen'],
    queryFn: getSlaResumen,
    refetchInterval: 60_000,   // el semáforo se refresca solo cada minuto
  })
}

export function useSlaInforme(mes) {
  return useQuery({
    queryKey: ['sla', 'informe', mes],
    queryFn: () => getSlaInforme(mes),
  })
}
